import Typography from '@material-ui/core/Typography/Typography';
import * as React from 'react';
import Title from '../../shared/Title/Title';
import { Button } from '@material-ui/core';
import history from '../../../history';
import Grid from '@material-ui/core/Grid';
import styles from './GoToPortal.module.css';

interface GoToPortalProps {}
const GoToPortal = ({  }: GoToPortalProps) => {
  return (
    <div>
      <Title text="It's Time to Ascend!" center />
      <Grid container alignItems="center" direction="column">
        <Grid item xs={11} sm={8} md={6}>
          <Typography variant="subheading" align="center">
            Congratulations! You've completed and submitted your Ascend Client Services Agreement.
          </Typography>
          <br />
          <Typography variant="subheading" align="center">
            Feel free to head to the portal to view/download your completed agreement and manage your debts over time!
          </Typography>
          <Grid container justify="center" className={styles.buttonRow}>
            <Button variant="outlined" color="primary" onClick={() => history.push('/home')}>
              Go To Portal
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
export default GoToPortal;
